<template>
  <div>
    <div>
      HELLO WORLD ERDG
    </div>

  </div>
</template>

<script>

export default {
  name: 'EssentialRegulatoryDocuments',
  components: {

  },
  data () {
    return {

    }
  },
  /// ////
  computed: {

  },
  /// ////
  mounted: function () {

  },
  /// ////
  methods: {
    showModal () {
      this.isModalVisible = true
    },
    closeModal () {
      this.isModalVisible = false
    }

  }
}

</script>
<style>

</style>
